import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import options from '@/configs/vuetify'

Vue.use(Vuetify)

export default new Vuetify(options)
